module.exports = __webpack_public_path__ + "img/2.eec9be5f.jpg";